import React, { useEffect, useState } from 'react'
import cn from 'classnames'
import Markdown from '@ui/Markdown'
import './styles.scss'

export default function ModuleHeader({ title, subtitle, collapsible }) {
  const [isCollapsed, setIsCollapsed] = useState(collapsible)

  useEffect(() => {
    setIsCollapsed(collapsible)
  }, [collapsible])

  const handleCollapse = () => setIsCollapsed(!isCollapsed)

  return (
    <div
      className={cn('module-header', { collapsed: isCollapsed })}
      onClick={collapsible ? handleCollapse : null}
    >
      <div className='module-header-container'>
        <Markdown className='module-title'>{title}</Markdown>
        <Markdown className='module-subtitle'>{subtitle}</Markdown>
      </div>
    </div>
  )
}
